import React from "react";
import { Message, Overlay } from "../../layout";

export default props => (
  <Overlay>
    <Message {...props} />
  </Overlay>
);



// WEBPACK FOOTER //
// ./src/components/generic/pages/Message/index.js